import "./instructions.css";
import instructions from "../../../core/helpers/instructions.json";
import { FiCheckCircle } from "react-icons/fi";
import { IoWarningOutline } from "react-icons/io5";
import ASSETS from "../../../app/config/assets";
import Button from "../../atoms/buttons/Button";

const Instructions = ({ title, type, onAction }) => {
  return (
    <div className="instructions">
      <div className="wrapper">
        <h1 className="title t-1">{title}</h1>
        <div className="w-full d-flex align-center gap-md">
          <hr />
          <h2 className="title t-2">Instructions</h2>
          <hr />
        </div>
        <p className="title t-3">
          You are about to begin an assessment designed to test your knowledge
          and skills on the given subject.
        </p>
        <p className="title t-3">
          Each question must be answered within a set time limit.
        </p>
        <div className="body">
          <div className="description">
            {instructions.map((row, idx) => {
              return (
                (row?.type === "common" || row?.type === type) && (
                  <div className="instruction-tile" key={idx}>
                    <span className="span-icon">
                      <FiCheckCircle className="icon" />
                    </span>
                    <span className="span-text">{row?.text}</span>
                  </div>
                )
              );
            })}
          </div>
          <img
            src={ASSETS?.icon_instructions_gif}
            alt="assessment instructions"
          />
          <div className="warning">
            <h1 className="title t-1">📌 Important Notes</h1>
            <div className="warning-tile">
              <span className="span-icon">
                <IoWarningOutline className="icon" />
              </span>
              <span className="span-text">
                Stay focused: You cannot pause or restart the test once started.
              </span>
            </div>
            <div className="warning-tile">
              <span className="span-icon">
                <IoWarningOutline className="icon" />
              </span>
              <span className="span-text">
                Keep your environment distraction-free.
              </span>
            </div>
            <div className="warning-tile">
              <span className="span-icon">
                <IoWarningOutline className="icon" />
              </span>
              <span className="span-text">
                If technical issues occur, notify the proctor (if applicable) or
                follow system instructions.
              </span>
            </div>
          </div>
        </div>
        <Button
          type={"button"}
          preferedStyle={"normal"}
          title={"I understand instructions, and I am ready to start!"}
          action={() => onAction()}
        />
      </div>
    </div>
  );
};

export default Instructions;
